

import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IAuthorizationUser } from "../model/domain/user-info";
import { IAuthorizationUserRestV2Service } from "./authorization-user-rest-v2";
import { appConfig } from "@env/app-config";
import type { WxEmailVerify, WxToken, WxTokenSession, WxUserInfo } from "../model/domain/wxEmailVerify";

export class AuthorizationUserRestV2Service extends AbstractAccessorService<IAuthorizationUser> implements IAuthorizationUserRestV2Service {
    public readonly $name: string = "authorizationUserRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<IAuthorizationUser>) {
        super();
    }

    /**
     * @description: 获取e-shopper信息
     * 
     */
    public login(email: string, password: string, googleResponse: string): angular.IPromise<IResponse<IAuthorizationUser>> {
        return this.$accessor<IAuthorizationUser, {}, string>(this.$name, "login", {
            data: {
                email: email,
                password: password,
                googleResponse: googleResponse
            }
        });
    }

    /**
     * @description: 注册发送partner验证邮件
     * 
     */
    public regist(userEmail: string, userPassword: string, userName: string, googleResponse: string): angular.IPromise<IResponse<string>> {
        return this.$accessor<string, {}, string>(this.$name, "regist", {
            data: {
                email: userEmail,
                password: userPassword,
                name: userName,
                googleResponse: googleResponse,
                platform: appConfig.websiteCode
            }
        });
    }

    public forget(userEmail: string, googleToken: string, url: string): angular.IPromise<IResponse<any>> {
        return this.$accessor<any, {}, string>(this.$name, "forget", {
            data: {
                email: userEmail,
                googleVerifyToken: googleToken,
                url: url,
                platform: appConfig.websiteCode
            }
        });
    }

    /**
     * @desription 重置密码
     * */
    public reset(password: string, token: string): angular.IPromise<IResponse<any>> {
        return this.$accessor<any, {}, string>(this.$name, "reset", {
            data: {
                password: password,
                token: token
            }
        });
    }
    /**
     * @desription wx 邮箱验证 是否绑定 验证是否新用户
     * */
    public wxEmailVerify(thirdAccessToken: string, thirdOAuthType: string): angular.IPromise<IResponse<WxEmailVerify>> {
        return this.$accessor<any, {}, string>(this.$name, "wxEmailVerify", {
            parameter: {
                thirdAccessToken: thirdAccessToken,
                thirdOAuthType: thirdOAuthType,
            }
        });
    }
    /**
     * @desription wx 邮箱绑定注册
     * */
    public wxEmailRegister(thirdAccessToken: string, email: string, username: string, platform: string, thirdOAuthType: string,): angular.IPromise<IResponse<WxToken>> {
        return this.$accessor<any, {}, string>(this.$name, "wxEmailRegister", {
            data: {
                thirdAccessToken: thirdAccessToken,
                email: email,
                username: username,
                platform: platform,
                thirdOAuthType: thirdOAuthType,
            }
        });
    }
    /**
     * @desription wx 邮箱绑定注册
     * */
    public wxGetAccessToken(appid: string, secret: string, js_code: string, grant_type: string): angular.IPromise<IResponse<WxTokenSession>> {
        return this.$accessor<any, {}, string>(this.$name, "wxEmailRegister", {
            data: {
                appid: appid,
                esecretmail: secret,
                js_code: js_code,
                grant_type: grant_type,
            }
        });
    }
    /**
     * @desription wx 邮箱绑定注册
     * */
    public wxGetUserInfo(openid: string, access_token: string, lang: string): angular.IPromise<IResponse<WxUserInfo>> {
        return this.$accessor<any, {}, string>(this.$name, "wxEmailRegister", {
            data: {
                openid: openid,
                access_token: access_token,
                lang: lang,
            }
        });
    }
}